import PropTypes from 'prop-types';
import { motion, AnimatePresence } from 'framer-motion';
import { useRef, useEffect, useState } from 'react';
import { Box } from 'theme-ui';
import useWindowSize from '~/hooks/components/use-window-size.js';

export default function Answer({ answer, open }) {
  const answerRef = useRef();
  const [height, setHeight] = useState();
  const window = useWindowSize();

  useEffect(() => {
    if (answerRef.current) {
      setHeight(answerRef.current.offsetHeight);
    }
  }, [answerRef, open, window]);

  const spring = {
    type: 'spring',
    damping: 20,
    stiffness: 100,
  };
  const child = {
    type: 'spring',
    damping: 20,
    stiffness: 100,
    delay: 0.3,
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          transition={spring}
          initial={{ opacity: 0, height: 0 }}
          animate={{
            height: height,
            overflow: 'visible',
            opacity: 1,
          }}
          exit={{ height: 0, opacity: 0 }}
          style={{ height: 0, overflow: 'hidden' }}
        >
          <motion.div
            transition={child}
            initial={{ opacity: 0, transform: 'translateY(-10%) rotateX(25deg)' }}
            animate={{ opacity: 1, transform: 'translateY(0%) rotateX(0deg)' }}
            style={{ opacity: 0 }}
          >
            <Box
              ref={answerRef}
              sx={{
                color: 'black',
                fontSize: ['13px', null, '15px'],
                a: { textDecoration: 'underline' },
                p: { my: 0, pt: '2.4rem' },
              }}
              dangerouslySetInnerHTML={{
                __html: answer,
              }}
            />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

Answer.propTypes = {
  answer: PropTypes.string,
  open: PropTypes.bool,
};
